export enum UserRoleEnum {
  Employee = 'employee',
  Company = 'company',
}
